var map = {
	"./img_1.jpg": 19344,
	"./img_2.jpg": 16581,
	"./img_3.jpg": 75452,
	"./img_4.jpg": 39645,
	"./img_5.jpg": 36569,
	"./img_6.jpg": 5150,
	"./img_7.jpg": 4256,
	"./img_8.jpg": 77106,
	"./img_9.jpg": 32745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19006;